/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function PlusCircleFill({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><rect width={16} height={16} fill="currentColor" rx={8} /><path fill="#fff" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth={0.3} d="M8.45 4.25a.45.45 0 1 0-.9 0v3.3h-3.3a.45.45 0 1 0 0 .9h3.3v3.3a.45.45 0 0 0 .9 0v-3.3h3.3a.45.45 0 1 0 0-.9h-3.3z" /></svg>;
}
;